import React, { useContext, useEffect, useState, useRef } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '@shared/context/AuthContext';
import { useLocalStorage } from './auth/useLocalStorage';
import staticData from '@utils/static/menu';

const ProtectedRoute = ({ children }: any) => {
    const { getStorageItem }: any = useLocalStorage();
    const location = useLocation();
    const [permissions, setPermission]: any = useState(false);
    const [currentMenu, setCurrentMenu]: any = useState(false);
    const navigate = useNavigate();
    // Get Current user
    const user = getStorageItem('user') ? JSON.parse(getStorageItem('user')) : false;

    // Check permissions for menu on frontend
    useEffect(() => {
        if (user) {
            let permissionsList = user.user_role.user_permissions;
            permissionsList = permissionsList.map(ele => ele.slug);
            const currentMenuFromList = searchMenu(staticData.menuData, location.pathname);
            if (
                currentMenuFromList &&
                permissionsList &&
                permissionsList.length &&
                location.pathname != '/home/dashboard' &&
                location.pathname != '/home/dashboard/' &&
                !permissionsList.includes(currentMenuFromList.route)
            ) {
                navigate('/', { state: { from: null }, replace: true });
            }
        }
    }, [location.pathname]);

    // Search menu in my menu list
    const searchMenu = (menuItems, term, parent = null) => {
        for (const menuItem of menuItems) {
            if (menuItem.route === term) {
                // Return the matching parent item
                return menuItem;
            }

            if (menuItem.subMenu && menuItem.subMenu.length > 0) {
                // Recursively search in subMenu
                const result = searchMenu(menuItem.subMenu, term, menuItem);

                // If the result is found in the subMenu, return it
                if (result) {
                    return result;
                }
            }
        }

        // Return null if no match is found
        return null;
    };
    //if (!user) return <div className="loader"></div>
    if (!getStorageItem('user')) {
        // If user exists
        return <Navigate to="/" state={{ from: location }} replace />;
    }
    if (location.pathname === '/home' || location.pathname === '/home/') {
        return <Navigate to="/home/dashboard" state={{ from: null }} replace />;
    }
    return children;
};

export default ProtectedRoute;
